import pino from 'pino';

function initialiseLogger(pinoImpl: typeof pino = pino) {
  const transport =
    process.env.NODE_ENV === 'development'
      ? {
          target: 'pino-pretty',
          options: {
            colorize: true,
          },
        }
      : undefined;
  return pinoImpl({
    level: process.env.NEXT_PUBLIC_LOG_LEVEL || 'debug',
    transport,
  });
}

export let logger = initialiseLogger();

export function resetLogger(pinoImpl: typeof pino = pino) {
  logger = initialiseLogger(pinoImpl);
  return logger;
}
